// extracted by mini-css-extract-plugin
var _1 = "PortalMspAlert_attentionIcon__6Pp7A";
var _2 = "PortalMspAlert_container__U4PUI";
var _3 = "PortalMspAlert_msp__ibOAD";
export { _1 as "attentionIcon", _2 as "container", _3 as "msp" }
